import { Parser } from '~/api';
import { Location } from '~/api/models';
import RequestService from './request';

interface CreateLocationRequest {
    short: string;
    long: string;
}

type UpdateLocationRequest = CreateLocationRequest;

interface DeleteLocationRequest {
    id: number;
}

class LocationsService {
    getAll(req: PaginatableRequest): Promise<ListResponse> {
        return RequestService.get('/locations', {
            ...req,
            include: ['nodesCount', 'serversCount'],
        }).then(Parser.parse);
    }

    // Every location, for a picker. The index caps per_page at 50, so walk the
    // pages rather than over-requesting (which 400s with per_page_out_of_range).
    async getAllForPicker(): Promise<Location[]> {
        const collected: Location[] = [];
        let page = 1;
        let totalPages = 1;

        do {
            const response = await this.getAll({ perPage: 50, page } as PaginatableRequest);
            collected.push(...((response.data ?? []) as unknown as Location[]));
            totalPages = response.meta?.pagination?.totalPages ?? 1;
            page++;
        } while (page <= totalPages);

        return collected;
    }

    get(): Promise<Location> {
        return RequestService.get('/locations/:location', {
            include: 'nodes',
        }).then(Parser.parse);
    }

    create(data: CreateLocationRequest): Promise<Location> {
        return RequestService.post('/locations', data).then(Parser.parse);
    }

    update(data: UpdateLocationRequest): Promise<Location> {
        return RequestService.put('/locations/:location', data).then(Parser.parse).then(RequestService.updateModelBinding);
    }

    delete(data: DeleteLocationRequest): Promise<void> {
        return RequestService.delete(`/locations/${data.id}`);
    }
}

export default new LocationsService();
